import { render, staticRenderFns } from "./JournalItems.vue?vue&type=template&id=f777d9d0"
import script from "./JournalItems.vue?vue&type=script&lang=js"
export * from "./JournalItems.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports